import { fmt, pct, sum } from "@/lib/api";

const cellCls = (v, type) => (type !== "pct" && v < -0.05 ? "neg" : "");

const FinRow = ({ r, showTotal, n }) => {
  if (r.type === "section" || r.type === "group") {
    return (
      <tr className={`row-${r.type}`} data-testid={`fin-row-${r.key}`}>
        <td className="sticky-col" style={{ paddingLeft: 12 + (r.indent || 0) * 14 }}>{r.label}</td>
        <td colSpan={n + (showTotal ? 1 : 0)} />
      </tr>
    );
  }
  const f = r.type === "pct" ? pct : fmt;
  const t = r.noTotal || r.type === "pct" ? null : sum(r.values);
  return (
    <tr className={`row-${r.type || "line"}`} data-testid={`fin-row-${r.key}`}>
      <td className="sticky-col" style={{ paddingLeft: 12 + (r.indent || 0) * 14 }}>
        <span>{r.label}</span>
        {r.meta && <span className="row-meta">{r.meta}</span>}
      </td>
      {showTotal && <td className={cellCls(t, r.type)}>{t == null ? "" : f(t)}</td>}
      {r.values.map((v, i) => (
        <td key={i} className={cellCls(v, r.type)}>{f(v)}</td>
      ))}
    </tr>
  );
};

export const FinTable = ({ years, rows, testid, showTotal = true, maxH = "68vh" }) => (
  <div className="fin-scroll rounded-lg border border-slate-800" style={{ maxHeight: maxH }} data-testid={testid}>
    <table className="fin-table">
      <thead>
        <tr>
          <th className="sticky-col">Line item (₹ Cr)</th>
          {showTotal && <th>Σ Horizon</th>}
          {years.map((y) => (
            <th key={y}>FY {y}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <FinRow key={r.key} r={r} showTotal={showTotal} n={years.length} />
        ))}
      </tbody>
    </table>
  </div>
);
